import logo from './logo.svg';
import './App.css';
import FuelPriceTracker from './FuelPriceTracker';

function App() {
  return (
    <div>
      <FuelPriceTracker />
    </div>
  );
}

export default App;
